import { Hidden, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Container, Image, BackgroundGreen, Info, Divider } from './styles';

export default function TechSession() {
  const { t } = useTranslation();

  return (
    <Container>
      <Hidden mdUp>
        <div className="back-image" />
      </Hidden>
      <Image />
      <BackgroundGreen>
        <Info>
          <header>
            <Typography variant="h1" color="textSecondary">
              {t('Tecnologia Exclusiva em Depilação a Laser')}
            </Typography>
          </header>
          <Divider />
          <div>
            <Typography component="p">
              {t(
                'Possuímos de forma exclusiva, a melhor tecnologia mundial em Depilação a Laser',
              )}
              {t('que abrange mais fototipos de pele')}
            </Typography>
            <Typography component="p">
              {t(
                'Nosso sistema de resfriamento torna o tratamento mais seguro e confortável',
              )}
            </Typography>
            <Typography component="p">
              {t(
                'Além disso, com uma maior área de contato, garantimos 40% mais agilidade na aplicação em relação à concorrência',
              )}
            </Typography>
          </div>
        </Info>
      </BackgroundGreen>
      <Hidden smDown>
        <BackgroundGreen />
      </Hidden>
    </Container>
  );
}
